<h1>Page not found :(</h1>

<style>
    h1{color:#38ada9;text-align:center;margin-top:15vh;}
</style>